import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import images from '../../assets/images';
import {SelectStyle} from '../../constants/SelectStyle';
import { EDIT_POST_MODAL } from '../../context/general/constants';
import { useGeneralDispatch, useGeneralState } from '../../context/general/generalContext';
import { useFileReader } from '../../hooks/useFileReader';
import { useRequest } from '../../hooks/useRequest';

const EditPostModal = () => {
  const [post, setPost] = useState({});
  const [categories, setCategories] = useState();
  const [imagesData, setImagesData, convert] = useFileReader();
  const { request, loading } = useRequest();
  const { editPostModal } = useGeneralState();
  const dispatch = useGeneralDispatch();
  const today = new Date().toISOString().split('T')[0];
  useEffect(() => {
    if (editPostModal.detail?.id) {
      request('post/getCategories').then((res) => {
        setCategories(res.data.result?.map(c => ({label:c.title,value:c.id,name:'category'})));
      });
      request(`post/getPostDetailForEditForEdit`, {
        params: {
          postId: editPostModal.detail.id
        }
      }).then((res) => {
        setPost(res.data.result);
      });
    }
  }, [editPostModal]);
  const removeOldImg = (index) => {
    setPost((prev) => ({
      ...prev,
      resources: [...prev.resources.filter((r, i) => i != index)]
    }));
  };
  const removeImg = (index) => {
    setImagesData((prev) => [...prev.filter((e, i) => i != index)]);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPost((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDropdownChange = (e) => {
    const { value, name } = e;
    setPost((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        id: value
      }
    }));
  };
  const handleImageChage = (e) => {
    convert(e.target.files);
  };

  const handleSubmit = async () => {
    const { category, description, title, resources, id, unPublishDate } = post;
    var data = new FormData();
    data.append('Model.CategoryId', category.id);
    data.append('Model.Description', description);
    data.append('Model.Title', title);
    data.append('Model.PostId', id);
    for (let i = 0; i < imagesData.length; i++) {
      if (imagesData[i].raw) {
        data.append('Model.Medias', imagesData[i].raw);
      }
    }
    for (let i = 0; i < resources.length; i++) {
      if (resources[i].url) {
        data.append('Model.OldMedias', resources[i].url);
      }
    }
    if (unPublishDate) {
      data.append('Model.UnPublishDate', unPublishDate);
    }
    await request('post/editPost', {
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: data
    }).then((res) => {
      if (res.data.ok) {
        closeModal();
        toast.success('Gönderiniz Güncellendi');
      }
    });
  };
  const closeModal = () => {
    dispatch({
      type: EDIT_POST_MODAL,
      payload: { open: false }
    });
  };
  return (
    <div className="modal" data-modal="data-modal">
      {/* Modal content */}
      <div className="modal-content">
        <img
          onClick={closeModal}
          className="modal-content--close"
          src={images.iconClose}
          alt="Close Icon"
          data-modal-close="data-modal-close"
        />
        {
          post && <div className="edit-post-modal">
          <div className="edit-post-modal--header">Gönderi Güncelle</div>
          <form className="edit-post-modal--form">
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <label className="edit-post-modal--form--row--item--label" htmlFor="category">
                  Kategori
                </label>
                {
                  categories && <Select styles={SelectStyle} onChange={handleDropdownChange} value={post.category && categories.find(c => c.value == post.category?.id)} placeholder='Kategori Seçiniz' options={categories} />
                }
              </div>
              <div className="edit-post-modal--form--row--item">
                <label className="edit-post-modal--form--row--item--label" htmlFor="unPublishDate">
                  Yayından Kaldırılacağı Tarih
                </label>
                <input
                  id="unPublishDate"
                  type="date"
                  onChange={handleChange}
                  min={today}
                  value={post.unPublishDate?.split('T')[0]}
                  placeholder="Yayından Kalkacağı Tarih (Opsiyonel)"
                  className="edit-post-modal--form--row--item--date-picker"
                  name="unPublishDate"
                />
              </div>
            </div>
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <label className="edit-post-modal--form--row--item--label" htmlFor="title">
                  Başlık
                </label>
                <textarea
                  id="title"
                  className="edit-post-modal--form--row--item--textarea"
                  placeholder="Bir Başlık Yazın"
                  name="title"
                  onChange={handleChange}
                  value={post.title}
                  cols={50}
                  rows={3}
                />
              </div>
            </div>
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <div className="edit-post-modal--form--row--item--file-uploader">
                  <div className="edit-post-modal--form--row--item--file-uploader--images">
                    {post.resources?.length > 0 &&
                      post.resources.map((imageItem, i) => (
                        <div
                          key={i}
                          className="edit-post-modal--form--row--item--file-uploader--images--item">
                          <img
                            className="edit-post-modal--form--row--item--file-uploader--images--item--close"
                            src={images.iconCloseWhite}
                            onClick={() => removeOldImg(i)}
                            alt="Close Icon"
                          />
                          {imageItem.url.split('.').at(-1) == 'avi' ? (
                            <video className="edit-post-modal--form--row--item--file-uploader--images--item--img">
                              <source src={imageItem.url} type="video/mp4" />
                              Your browser does not support HTML5 video.
                            </video>
                          ) : (
                            <img
                              className="edit-post-modal--form--row--item--file-uploader--images--item--img"
                              src={imageItem.url}
                            />
                          )}
                        </div>
                      ))}
                    {imagesData.length > 0 &&
                      imagesData.map((image, i) => (
                        <div
                          key={i}
                          className="edit-post-modal--form--row--item--file-uploader--images--item">
                          <img
                            className="edit-post-modal--form--row--item--file-uploader--images--item--close"
                            src={images.iconCloseWhite}
                            onClick={() => removeImg(i)}
                            alt="Close Icon"
                          />
                          {image.raw?.type?.includes('video') ? (
                            <video width="60">
                              <source src={image.url} type={image.raw?.type} />
                              Your browser does not support HTML5 video.
                            </video>
                          ) : (
                            <img
                              className="edit-post-modal--form--row--item--file-uploader--images--item--img"
                              src={image.url}
                            />
                          )}
                        </div>
                      ))}
                  </div>
                  <label
                    className="edit-post-modal--form--row--item--file-uploader--label"
                    htmlFor="file-uploader">
                    <img
                      className="edit-post-modal--form--row--item--file-uploader--label--img"
                      src={images.iconUpload}
                      alt="Upload Image"
                    />
                    <span className="edit-post-modal--form--row--item--file-uploader--label--text">
                      Fotoğraf Seçin
                    </span>
                  </label>
                  <input
                    onChange={handleImageChage}
                    type="file"
                    accept="image/*"
                    multiple
                    id="file-uploader"
                    className="edit-post-modal--form--row--item--file-uploader--input"
                  />
                </div>
              </div>
            </div>
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <label className="edit-post-modal--form--row--item--label" htmlFor="description">
                  Açıklama
                </label>
                <textarea
                  id="description"
                  className="edit-post-modal--form--row--item--textarea"
                  placeholder="Post Detay Metni Girin"
                  rows={6}
                  value={post.description}
                  name="description"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <div className="edit-post-modal--form--row--item--button">
                  <button
                    type="button"
                    disabled={loading}
                    className="default-green-button"
                    onClick={handleSubmit}>
                    İçeriği Güncelle
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        }
      </div>
    </div>
  );
};

export default EditPostModal;
